import { units } from '@ui/css';
import { combineTokens, makeScaleableToken } from '@utils/css';

const tokens = combineTokens("--dropzone", {
  left: "0%",
  top: "0%",
  width: "0%",
  height: "0%",
  padding: [units.px(10), makeScaleableToken]
});
const emptyDropzone = "_35sez68kor";
const placeholder = "_35sp19tbnh1";

export { emptyDropzone, placeholder, tokens };
import "./atom.empty.style.linaria.module.css";
//# sourceMappingURL=atom.empty.style.js.map
